import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared site footer — carries trust / policy links (About, Privacy,
 * Terms, Content Policy, Changelog, Support) plus canonical funnel
 * links. Kept intentionally text-heavy so LLM crawlers pick up the
 * trust-signal URLs without any JS.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-amber-700/15 bg-[#0a0809] text-amber-100/70 mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 font-body text-sm">
        <div>
          <h3 className="font-display text-amber-200 text-base mb-3">TalesTalesTales</h3>
          <p className="text-amber-100/55 leading-relaxed">
            An interactive AI Novel — illustrated, choice-driven story worlds
            with a Memory Codex that tracks important story details.
          </p>
        </div>
        <div>
          <h4 className="font-ui uppercase tracking-widest text-[10px] text-amber-400/70 mb-3">
            Play
          </h4>
          <ul className="space-y-1.5">
            <li><Link data-testid="footer-link-trial"    to="/trial"       className="hover:text-amber-200">Free 5-turn trial</Link></li>
            <li><Link data-testid="footer-link-register" to="/register"    className="hover:text-amber-200">Register free</Link></li>
            <li><Link data-testid="footer-link-worlds"   to="/worlds"      className="hover:text-amber-200">Browse worlds</Link></li>
            <li><Link data-testid="footer-link-howto"    to="/how-to-play" className="hover:text-amber-200">How to play</Link></li>
            <li><Link data-testid="footer-link-pricing"  to="/pricing"     className="hover:text-amber-200">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-ui uppercase tracking-widest text-[10px] text-amber-400/70 mb-3">
            Company
          </h4>
          <ul className="space-y-1.5">
            <li><Link data-testid="footer-link-about"     to="/about"     className="hover:text-amber-200">About</Link></li>
            <li><Link data-testid="footer-link-changelog" to="/changelog" className="hover:text-amber-200">Changelog</Link></li>
            <li><Link data-testid="footer-link-support"   to="/support"   className="hover:text-amber-200">Contact / Support</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-ui uppercase tracking-widest text-[10px] text-amber-400/70 mb-3">
            Policies
          </h4>
          <ul className="space-y-1.5">
            <li><Link data-testid="footer-link-privacy"  to="/privacy"        className="hover:text-amber-200">Privacy</Link></li>
            <li><Link data-testid="footer-link-terms"    to="/terms"          className="hover:text-amber-200">Terms</Link></li>
            <li><Link data-testid="footer-link-content"  to="/content-policy" className="hover:text-amber-200">Content policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-amber-700/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 font-body text-xs text-amber-100/40">
          <p>&copy; {year} TalesTalesTales — Interactive AI Novel.</p>
          <p className="flex gap-3">
            <a href="/sitemap.xml" className="hover:text-amber-200">sitemap.xml</a>
            <a href="/robots.txt"  className="hover:text-amber-200">robots.txt</a>
            <a href="/llms.txt"    className="hover:text-amber-200">llms.txt</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
